export enum OrderState {
  pending,
  succeeded,
  failed,
  error,
}
